const axios = require('axios');
// JavaScript pour fermer le bandeau de téléchargement de l'app mobile et définir le cookie
if(document.getElementById("close-banner-button")){
    document.getElementById('close-banner-button').addEventListener('click', function () {
        axios.post('disable-app-store-banner')
            .then(function(response){
                if(response.data === 1 ) {
                    document.querySelector('.banner-app-download').style.display = 'none';
                }
            })
            .catch(function (error){
                console.log(error)
            })
    });
}